<template>
  <BaseBreadcrumbs
    :is-trimmed="blok.trim"
    :text-override="blok.text_override"
  />
</template>

<script setup lang="ts">
import type { SbBreadcrumbs } from '@/types'
interface Props {
  blok: SbBreadcrumbs
}

defineProps<Props>()
</script>
